export default "__VITE_ASSET__16bd9914__"